import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import { LightboxModule } from 'ngx-lightbox';

import { HeaderComponent } from './Header/Header.component';
import { FooterComponent } from './Footer/Footer.component';
import { MenuComponent } from './Menu/Menu.component';
import { AdminHeaderComponent } from './private-header/private-header.component';
import { AdminSidebarComponent } from './AdminSidebar/AdminSidebar.component';
import { FrontendPanelLayoutComponent } from './frontend-layout/FrontendPanel.component';
import { PrivateLayoutComponent } from './private-layout/private-layout.component';
import { FilePickerComponent } from './file-picker/file-picker.component';
import { ImageLightboxComponent } from './image-lightbox/image-lightbox.component';
import { PipesModule } from './pipes/pipes.module';
import { ReactiveFormsModule } from '@angular/forms';
import { AccountServicesModule } from '../account/account-services.module';
import { FrontendPanelNoFooterLayoutComponent } from './frontend-nofooter-layout/FrontendPanelNoFooter.component';
import { ImageCompressionServicesModule } from '../core/image-compression/image-compression-services.module';
import { GoogleAnalyticsGTagComponent } from './google-analytics-component/google-analytics.component';

@NgModule({
	imports: [
		CommonModule,
		RouterModule,
		LightboxModule,
		PipesModule,
		ReactiveFormsModule,
		AccountServicesModule,
		ImageCompressionServicesModule,
	],
	declarations: [
		FrontendPanelLayoutComponent,
		FrontendPanelNoFooterLayoutComponent,
		HeaderComponent,
		FooterComponent,
		MenuComponent,
		AdminHeaderComponent,
		AdminSidebarComponent,
		PrivateLayoutComponent,
		FilePickerComponent,
		ImageLightboxComponent,
		GoogleAnalyticsGTagComponent
	],
	exports: [
		FrontendPanelLayoutComponent,
		FrontendPanelNoFooterLayoutComponent,
		HeaderComponent,
		FooterComponent,
		MenuComponent,
		AdminHeaderComponent,
		AdminSidebarComponent,
		PrivateLayoutComponent,
		FilePickerComponent,
		ImageLightboxComponent,
		GoogleAnalyticsGTagComponent
	]
})
export class SharedModule { }
